import React, { useEffect, useRef } from 'react';

/**
 * 특정 영역 밖 클릭 action을 핸들링하는 컴포넌트
 */

interface Props<T = HTMLDivElement> {
  isOpen?: boolean;
  toggleAreaRef?: React.RefObject<T>;
  onClickOutside: () => void;
}

const ClickOutside: React.FC<Props> = ({
  isOpen = false,
  toggleAreaRef = null,
  onClickOutside,
  children,
}) => {
  const containerRef = useRef<HTMLDivElement | null>(null);

  const handleClickOutside = (e) => {
    // 바같영역이 클릭되면
    if (containerRef.current && !containerRef.current?.contains(e.target)) {
      if (
        isOpen && // 오픈되어있는지 체크  ex) dropdown
        toggleAreaRef && // 토클하는 클릭 영역이 있다면, 이 영역 클릭 이벤트인지 체크 => 클릭 이벤트는 여기에서 핸들링 X  ex) dropdown 하는 button
        !toggleAreaRef.current?.contains(e.target)
      ) {
        onClickOutside();
      }
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside, false);
    return () =>
      document.removeEventListener('mousedown', handleClickOutside, false);
  });

  return <div ref={containerRef}>{children}</div>;
};

export default ClickOutside;
